import Button from '@components/buttons/button/button.component'
import { useTranslation } from 'react-i18next'
import './incomplete-payment-data.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  redirect?: (path: string) => any
}

export default ({ redirect }: Props) => {
  const [t] = useTranslation('incompletePaymentData')

  return (
    <section className="incomplete-payment-data">
      <div className="incomplete-payment-header">
        <h5>
          <i className="mr-2 fa-solid fa-diamond-exclamation" style={{ color: 'var(--gold)' }}></i>
          {t('title')}
        </h5>
        <p>{t('text')}</p>
        <Button
          id="incomplete-payment-data-redirect"
          onClick={() => redirect('/payments/data')}
          size="sm"
          color="transparent"
          textColor="var(--primary_color)"
          borderColor="var(--primary_color)"
        >
          <span>{t('button')}</span>
        </Button>
      </div>
    </section>
  )
}
